export default [
  {
    path: '/report/payment-statistics',
    name: 'paymentStatistic',
    meta: { requiresAuth: true },
    component: () => import('./views/index.vue')
  }
]
